var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 34433"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.317677 1.15557C0.741245 0.731998 1.42799 0.731998 1.85155 1.15557L14.8669 14.171C15.2905 14.5945 15.2905 15.2813 14.8669 15.7048C14.4434 16.1284 13.7566 16.1284 13.3331 15.7048L0.317677 2.68944C-0.105892 2.26588 -0.105892 1.57914 0.317677 1.15557Z",
    fill: "#CDCEF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8669 1.15557C15.2905 1.57914 15.2905 2.26588 14.8669 2.68944L1.85155 15.7048C1.42799 16.1284 0.741245 16.1284 0.317677 15.7048C-0.105892 15.2813 -0.105892 14.5945 0.317677 14.171L13.3331 1.15557C13.7566 0.731998 14.4434 0.731998 14.8669 1.15557Z",
    fill: "#CDCEF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel_icon.028d59514c5e1c566a3a26aa83e1a038.svg";
export { ForwardRef as ReactComponent };